import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-cloud-compliance',
  imports: [CommonModule, RouterLink],
  templateUrl: './cloud-compliance.html',
  styleUrl: './cloud-compliance.css',
})
export class CloudCompliance {
  services = [
    {
      title: 'PCI DSS Compliance',
      description: 'Protect payment card data with comprehensive PCI DSS compliance audits and implementation services.',
      link: '/cloud-compliance/pci',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&h=300&fit=crop'
    },
    {
      title: 'SOC 2 Compliance',
      description: 'Demonstrate trust and security with SOC 2 Type I and Type II compliance certification.',
      link: '/cloud-compliance/soc2',
      image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400&h=300&fit=crop'
    },
    {
      title: 'HIPAA Compliance',
      description: 'Secure protected health information with comprehensive HIPAA compliance solutions.',
      link: '/cloud-compliance/hipaa',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400&h=300&fit=crop'
    },
    {
      title: 'ISO 27001 Certification',
      description: 'Achieve international security standards with ISO 27001 compliance and certification.',
      link: '/cloud-compliance/iso27001',
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&h=300&fit=crop'
    },
    {
      title: 'GDPR Compliance',
      description: 'Ensure data privacy and protection with comprehensive GDPR compliance solutions.',
      link: '/cloud-compliance/gdpr',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop'
    }
  ];

  caseStudies = [
    {
      client: 'Global FinTech Solutions',
      industry: 'Financial Services',
      challenge: 'Needed PCI DSS Level 1 compliance to process over $1B in annual transactions.',
      solution: 'Implemented comprehensive security controls and continuous monitoring.',
      results: ['100% compliance in 6 months', 'Zero security incidents', '$1B+ transactions secured'],
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=600&h=400&fit=crop'
    },
    {
      client: 'HealthBridge Platform',
      industry: 'Healthcare Technology',
      challenge: 'Required HIPAA certification to serve 500,000+ patients securely.',
      solution: 'Deployed end-to-end encryption and PHI protection framework.',
      results: ['Zero compliance violations', '500K+ patients protected', 'PHI fully secured'],
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=400&fit=crop'
    },
    {
      client: 'CloudMetrics SaaS',
      industry: 'Software as a Service',
      challenge: 'Needed SOC 2 Type II to unlock enterprise sales opportunities.',
      solution: 'Built trust services framework with continuous compliance monitoring.',
      results: ['300% increase in enterprise deals', 'SOC 2 Type II certified', 'Enhanced market position'],
      image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&h=400&fit=crop'
    }
  ];

  testimonials = [
    {
      quote: 'HoneyKode made our PCI DSS compliance journey seamless. Their expertise saved us months of effort.',
      author: 'Sarah Chen',
      role: 'CISO',
      company: 'PaymentFlow Inc.',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
    },
    {
      quote: 'Achieving SOC 2 Type II seemed impossible until we partnered with HoneyKode. Highly recommended.',
      author: 'Michael Rodriguez',
      role: 'VP of Security',
      company: 'CloudMetrics',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop'
    },
    {
      quote: 'The HIPAA compliance framework improved our overall security architecture significantly.',
      author: 'Dr. Emily Watson',
      role: 'CTO',
      company: 'HealthBridge Platform',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
    }
  ];

  stats = [
    { value: '500+', label: 'Audits Completed' },
    { value: '99.8%', label: 'Compliance Rate' },
    { value: '250+', label: 'Clients Protected' },
    { value: '12+', label: 'Years Experience' }
  ];
}
